var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { default as AntInput } from 'antd/lib/input';
import { isEqual } from 'lodash';
import { basicPropTypes, controlPropTypes } from '../component-props';
/**
 * 文本输入框
 */

var Searchbox = function (_super) {
  __extends(Searchbox, _super);

  function Searchbox(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Searchbox.prototype.handleChange = function (value) {
    var _a = this.props,
        name = _a.name,
        onChange = _a.onChange;

    if (onChange) {
      onChange(value, name);
    }
  };

  Searchbox.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  Searchbox.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        name = _a.name,
        placeholder = _a.placeholder,
        disabled = _a.disabled;
    var inputProps = {
      // basicPropTypes
      className: className,
      style: style,
      // controlPropTypes
      name: name,
      placeholder: placeholder,
      disabled: disabled,
      onSearch: this.handleChange
    };
    return React.createElement(AntInput.Search, __assign({}, inputProps));
  };

  Searchbox.defaultProps = {
    type: 'text'
  };
  Searchbox.propTypes = __assign(__assign({}, basicPropTypes), controlPropTypes);
  return Searchbox;
}(Component);

export { Searchbox };